import { getLastItem } from './array.esm.js';
import { isArray, isObject } from './assertion.esm.js';
import { objectKeys } from './object.esm.js';

/* eslint-disable @typescript-eslint/no-explicit-any */
var breakpoints = Object.freeze(['base', 'sm', 'md', 'lg', 'xl']);
function mapResponsive(prop, mapper) {
  if (isArray(prop)) {
    return prop.map(function (item) {
      if (item === null) {
        return null;
      }
      return mapper(item);
    });
  }
  if (isObject(prop)) {
    return objectKeys(prop).reduce(function (result, key) {
      result[key] = mapper(prop[key]);
      return result;
    }, {});
  }
  if (prop != null) {
    return mapper(prop);
  }
  return null;
}
function objectToArrayNotation(obj) {
  var bps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : breakpoints;
  var result = bps.map(function (br) {
    var _obj$br;
    return (_obj$br = obj[br]) !== null && _obj$br !== void 0 ? _obj$br : null;
  });
  while (getLastItem(result) === null) {
    result.pop();
  }
  return result;
}
function arrayToObjectNotation(values) {
  var bps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : breakpoints;
  var result = {};
  values.forEach(function (value, index) {
    var key = bps[index];
    if (value == null) return;
    result[key] = value;
  });
  return result;
}
function isResponsiveObjectLike(obj) {
  var bps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : breakpoints;
  var keys = Object.keys(obj);
  return keys.length > 0 && keys.every(function (key) {
    return bps.includes(key);
  });
}

export { arrayToObjectNotation, breakpoints, isResponsiveObjectLike, mapResponsive, objectToArrayNotation };
//# sourceMappingURL=responsive.esm.js.map
